<template>
  <div class="d-inline-block py-0">
    <span
      v-if="nickname"
      @click="getMemberInfo(playerno, 'player_pk')"
      class="more"
    >
      {{ displayText || nickname }}
    </span>
    <b-modal
      id="modal-info-member"
      ref="modal-info-member"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.membership.member_information") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-info-member')"
        ></b-button>
      </template>

      <p class="modal-subtitle">
        {{ $t("title.membership.basic_information") }}
      </p>
      <div
        class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4 table-type header-col p-keep"
      >
        <div class="col-sm">
          {{ $t("title.common.nickname") }}
        </div>
        <div class="col-sm">
          {{ playerbasicinfo && playerbasicinfo.nickname }}
        </div>
        <div class="col-sm">
          {{ $t("title.common.gender") }}
        </div>
        <div class="col-sm">
          {{ playerbasicinfo && changeGender(playerbasicinfo.gender) }}
        </div>

        <div class="col-sm border-bottom-lg-0">
          {{ $t("title.common.favorite_location") }}
        </div>
        <div class="col-sm shop-name border-bottom-lg-0">
          {{ playerbasicinfo.shopname }}
        </div>
        <div class="col-sm">
          {{ $t("title.common.join_date") }}
        </div>
        <div class="col-sm text-date">
          {{ playerbasicinfo.timezone_date | dateformat }}
        </div>
      </div>

      <p class="modal-subtitle mt-4">
        {{ $t("title.membership.round_summary") }}
      </p>
      <div
        class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4 table-type header-col p-keep"
      >
        <div class="col-sm">
          {{ $t("title.common.avg_putts_distance") }}
        </div>
        <div class="col-sm">{{ playerpalyinfo.avggreenhit | toFixed }}m</div>
        <div class="col-sm">
          {{ $t("title.membership.total_rounds") }}
        </div>
        <div class="col-sm">
          {{ playerpalyinfo.playcnt || 0 | comma }}
        </div>

        <div class="col-sm">
          {{ $t("title.membership.avg_distance") }}
        </div>
        <div class="col-sm">{{ playerpalyinfo.avgdriver | toFixed }}m</div>
        <div class="col-sm">
          {{ $t("title.membership.fareway_hit") }}
        </div>
        <div class="col-sm">{{ playerpalyinfo.farewayrate | toFixed }}%</div>

        <div class="col-sm">
          {{ $t("title.membership.gir") }}
        </div>
        <div class="col-sm">{{ playerpalyinfo.greenrate | toFixed }}%</div>
        <div class="col-sm">
          {{ $t("title.membership.par_save_rate") }}
        </div>
        <div class="col-sm">{{ playerpalyinfo.parsaverate | toFixed }}%</div>

        <div class="col-sm border-bottom-lg-0">
          {{ $t("title.membership.avg_stroke") }}
        </div>
        <div class="col-sm border-bottom-lg-0">
          {{ playerpalyinfo.avgshot | toFixed | comma }}
        </div>
        <div class="col-sm">
          {{ $t("title.membership.best_stroke") }}
        </div>
        <div class="col-sm">
          {{ playerpalyinfo.minshot | toFixed | comma }}
        </div>
      </div>

      <p class="mt-2 text-end text-subscript text-red">
        * {{ $t("text.membership.18hole_finish") }}
      </p>

      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-info-member')"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/tournament";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";
export default {
  name: "MemberInfo",
  props: {
    nickname: String,
    playerno: String,
    displayText: String,
  },
  data() {
    return {
      // playerno: "",
      playerbasicinfo: [],
      playerpalyinfo: [],
    };
  },
  methods: {
    getMemberInfo(player, type) {
      ax.get_playerinfo(player, type, (flag, data) => {
        if (flag) {
          // this.playerno = playerno;
          this.playerbasicinfo = data.playerbasicinfo;
          console.log(this.playerbasicinfo);
          this.playerpalyinfo = data.playerpalyinfo;
          this.$refs["modal-info-member"].modalOuterStyle.zIndex = 9999;
          this.$refs["modal-info-member"].show();
        } else {
          alert(data.message);
        }
      });
    },
  },
  mixins: [myMixin],
};
</script>
